import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { useOffline } from "../offline/OfflineContext";
import { useGlobalContext } from "../Config";

const Login = ({ handleLogin }) => {
  const { styleProperties } = useGlobalContext();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { offlineMode, setOfflineMode } = useOffline();

  const handleUsernameChange = (e) => setUsername(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(username, password);
  };

  const handleLimpiar = () => {
    setUsername("");
    setPassword("");
    setShowPassword(false);
  };

  return (
    <div
      className="flex align-items-center justify-content-center min-h-screen"
      style={{ backgroundColor: styleProperties.backgroundColor }}
    >
      <div className="surface-card p-5 shadow-4 border-round-2xl w-full lg:w-4 md:w-6 sm:w-10 m-3 bg-white">
        <div className="text-center mb-5">
          <img
            src={styleProperties.logo}
            alt="Logo"
            height="60"
            className="mb-3"
          />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid align-items-center">
            <label
              htmlFor="usuario"
              className="col-12 md:col-4 text-900 font-medium"
            >
              Usuario
            </label>
            <div className="col-12 md:col-8">
              <InputText
                id="usuario"
                type="text"
                value={username}
                onChange={handleUsernameChange}
                className="w-full p-inputtext-sm"
                autoComplete="off"
              />
            </div>

            <label
              htmlFor="password"
              className="col-12 md:col-4 text-900 font-medium"
            >
              Contraseña
            </label>
            <div className="col-12 md:col-8">
              <div className="p-inputgroup w-full">
                <InputText
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePasswordChange}
                  className="w-full p-inputtext-sm"
                  autoComplete="off"
                />
                <Button
                  type="button"
                  icon={showPassword ? "pi pi-eye" : "pi pi-eye-slash"}
                  onClick={toggleShowPassword}
                  className="p-button-text p-button-secondary"
                />
              </div>
            </div>

            <div className="col-12">
              <div className="flex justify-content-center align-items-center gap-3 mt-3 mb-2">
                <span className="font-medium">
                  {offlineMode ? "Modo OFFLINE" : "Modo ONLINE"}
                </span>

                <InputSwitch
                  checked={offlineMode}
                  onChange={(e) => setOfflineMode(e.value)}
                />
              </div>

              <small className="block text-center text-500">
                {offlineMode
                  ? "Se utilizarán los datos sincronizados almacenados en este equipo."
                  : "La autenticación se realizará contra el servidor."}
              </small>
            </div>

            <div className="col-12 md:col-4" />
            <div className="col-12 md:col-8">
              <div className="flex justify-content-center md:justify-content-start gap-2">
                <Button
                  label="Aceptar"
                  type="submit"
                  className="p-button-sm p-button-info p-button-outlined"
                />
                <Button
                  label="Limpiar"
                  type="button"
                  onClick={handleLimpiar}
                  className="p-button-sm p-button-info p-button-outlined"
                />
                <Button
                  label="Recuperar"
                  type="button"
                  className="p-button-sm p-button-info p-button-outlined"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
